import { render } from "./EditExitDeclarationStatusPage.vue?vue&type=template&id=306115d8"
import script from "./EditExitDeclarationStatusPage.vue?vue&type=script&lang=js"
export * from "./EditExitDeclarationStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__